import { useMemo } from "react";
import { FetchOptions } from "@danishagro/shared/src/interfaces/fetchOptions.interface";
import { getApiUrl } from "@danishagro/shared/src/helpers/getApiUrl.helper";
import { B2C_API_ROOT } from "@danishagro/shared/src/constants/urlRoot.constants";
// import { useAppData } from "@danishagro/shared/src/contexts/appData.context";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type QueryObject = Record<string, any>;

export const useBasketRequest = () => {
    // const { fetchWithAuthB2C } = useAppData();

    // TODO: Get from url urlRoot.constants
    // const B2C_API_ROOT =
    // "https://ca-b2c-apigateway-uat.lemonbush-fa53a445.westeurope.azurecontainerapps.io";

    return useMemo(
        () => ({
            get: (
                path: string,
                secret?: string,
                parameters?: QueryObject,
                options?: FetchOptions
            ) => {
                const opts = {
                    ...options,
                    headers: {
                        "x-basket-secret": secret,
                    },
                };
                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }
                return fetch(getApiUrl(B2C_API_ROOT, path, parameters), opts).then(
                    (response) => response
                );
            },
            post: (
                path: string,
                secret?: string,
                parameters?: QueryObject | string | number | boolean,
                options?: FetchOptions
            ) => {
                const opts = {
                    ...options,
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        ...(secret && { "x-basket-secret": secret }),
                    },
                    body:
                        typeof parameters === "object"
                            ? JSON.stringify(parameters)
                            : typeof parameters !== "string"
                            ? parameters?.toString()
                            : parameters,
                };

                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }

                return fetch(getApiUrl(B2C_API_ROOT, path), opts).then((data) => data);
            },
            patch: (
                path: string,
                secret?: string,
                parameters?: QueryObject | string | number | boolean,
                options?: FetchOptions
            ) => {
                const opts = {
                    ...options,
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        ...(secret && { "x-basket-secret": secret }),
                    },
                    body:
                        typeof parameters === "object"
                            ? JSON.stringify(parameters)
                            : typeof parameters !== "string"
                            ? parameters?.toString()
                            : parameters,
                };

                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }
                // console.log("PATCH", path, getApiUrl(B2C_API_ROOT, path));

                return fetch(getApiUrl(B2C_API_ROOT, path), opts).then((data) => data);
            },
            delete: (
                path: string,
                secret: string,
                parameters: QueryObject | string | number | boolean,
                options?: FetchOptions
            ) => {
                const opts = {
                    ...options,
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "x-basket-secret": secret,
                    },
                    body:
                        typeof parameters === "object"
                            ? JSON.stringify(parameters)
                            : typeof parameters !== "string"
                            ? parameters.toString()
                            : parameters,
                };

                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }

                return fetch(getApiUrl(B2C_API_ROOT, path), opts).then((data) => data);
            },
            put: (
                path: string,
                secret?: string,
                parameters?: QueryObject | string | number | boolean,
                options?: FetchOptions
            ) => {
                const opts = {
                    ...options,
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        ...(secret && { "x-basket-secret": secret }),
                    },
                    body:
                        typeof parameters === "object"
                            ? JSON.stringify(parameters)
                            : typeof parameters !== "string"
                            ? parameters?.toString()
                            : parameters,
                };

                if (globalThis.isAuthenticated) {
                    opts.headers["Authorization"] = `Bearer ${globalThis.accessToken}`;
                }

                return fetch(getApiUrl(B2C_API_ROOT, path), opts).then((data) => data);
            },
        }),
        []
    );
};
